import request from '../request';

export const portalApi = {
    login: (data= {}) => request.post('/login', data),
    coursePageList: (data= {}) => request.post('/course/pageList', data),
    qaPageList: (data= {}) => request.post('/qa/pageList', data),
};